import { defineMessages } from 'react-intl';

export default defineMessages({
    LeadLabel: {
        id: 'cep.components.sgSptRenewalSummary.LeadLabelMessage',
        defaultMessage: 'Lead traveller:'
    },
    AdditionalTravellersLabel: {
        id: 'cep.components.sgSptRenewalSummary.AdditionalTravellersLabel',
        defaultMessage: 'Additional traveller(s):'
    },
    ShowMoreTravellersLink: {
        id: 'cep.components.sgSptRenewalSummary.ShowMoreTravellersLink',
        defaultMessage: 'View all travellers'
    },
    ShowLessTravellersLink: {
        id: 'cep.components.sgSptRenewalSummary.ShowLessTravellersLink',
        defaultMessage: 'Show less'
    },
    StartDateLabel: {
        id: 'cep.components.sgSptRenewalSummary.StartDateLabelMessage',
        defaultMessage: 'Start of cover:'
    },
    RenewalDateLabel: {
        id: 'cep.components.sgSptRenewalSummary.RenewalDateLabelMessage',
        defaultMessage: 'Renewal date:'
    },
    CoverLabel: {
        id: 'cep.components.sgSptRenewalSummary.CoverLabelMessage',
        defaultMessage: 'Cover level:'
    },
    RegionLabel: {
        id: 'cep.components.sgSptRenewalSummary.RegionMessage',
        defaultMessage: 'Region:'
    },
    AdditionalCoverLabel: {
        id: 'cep.components.sgSptRenewalSummary.AdditionalCoverMessage',
        defaultMessage: 'Additional cover(s) included:'
    },
    SelectCoverLevel: {
        id: 'cep.components.sgSptRenewalSummary.SelectCoverLevel',
        defaultMessage: 'Saga Select Annual'
    },
    WinterSportsCover: {
        id: 'cep.components.sgSptRenewalSummary.WinterSportsCover',
        defaultMessage: 'Winter Sports cover ({winterSportsTraveller})'
    },
    SptRenewalSummaryRegionHelperLink: {
        id: 'cep.components.sgSptRenewalSummary.sptRenewalSummaryRegionHelperLink',
        defaultMessage: 'Not sure if the region is correct? Click here'
    }
});
